var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3398_77188",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3398_77188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.075 15.55C11.9417 15.55 11.8125 15.525 11.6875 15.475C11.5625 15.425 11.4583 15.3583 11.375 15.275L6.775 10.675C6.59167 10.4917 6.5 10.2583 6.5 9.975C6.5 9.69167 6.59167 9.45833 6.775 9.275C6.95833 9.09167 7.19167 9 7.475 9C7.75833 9 7.99167 9.09167 8.175 9.275L12.075 13.175L15.975 9.275C16.1583 9.09167 16.3917 9 16.675 9C16.9583 9 17.1917 9.09167 17.375 9.275C17.5583 9.45833 17.65 9.69167 17.65 9.975C17.65 10.2583 17.5583 10.4917 17.375 10.675L12.775 15.275C12.675 15.375 12.5667 15.4458 12.45 15.4875C12.3333 15.5292 12.2083 15.55 12.075 15.55Z",
    fill: "#2EBF93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/keyboard_arrow_down.6df43d99367ac16181e00f7b0fa77267.svg";
export { ForwardRef as ReactComponent };